import React, { useState } from "react";

import nextIcon from "./../assets/next-icon.png";
import prevIcon from "./../assets/prev-icon.png";

import mainvideoPoster from "../assets/home/video1-thumbail.jpg";
import video1Poster from "../assets/home/video1Thumbail.jpg";
import video1Poster2 from "../assets/home/video2Thumbail.jpg";

import Video from "../assets/home/video1.mp4";
import Video2 from "../assets/home/video2.mp4";
import Video3 from "../assets/home/video3.mp4";
import mainVideo from "../assets/home/video1-carousel.mp4";

import "./Carousel.css";

function Carousel() {
  const [current, setCurrent] = useState(0);
  const [showControls, setShowControls] = useState(false);

  const videos = [
    {
      src: mainVideo,
      poster: mainvideoPoster,
    },
    {
      src: Video,
      poster: video1Poster,
    },
    {
      src: Video2,
      poster: video1Poster2,
    },
    {
      src: Video3,
    },
  ];

  const resetCurrentVideo = () => {
    const currentVideo = document.querySelector(
      `.carousel-video-slide:nth-child(${current + 1}) video`
    );

    if (currentVideo) {
      currentVideo.pause();
      currentVideo.currentTime = 0;
      currentVideo.load();
    }

    setShowControls(false);
  };

  const nextVideo = () => {
    resetCurrentVideo();

    setCurrent((prev) => {
      if (prev === videos.length - 1) {
        return 0;
      }

      return prev + 1;
    });
  };

  const previousVideo = () => {
    resetCurrentVideo();

    setCurrent((prev) => {
      if (prev === 0) {
        return videos.length - 1;
      }

      return prev - 1;
    });
  };

  return (
    <section className="carousel-video-container">

      <div className="carousel-video-window">

        <div
          className="carousel-video-track"
          style={{
            transform: `translateX(-${current * 100}%)`,
          }}
        >
          {videos.map((video, index) => (
            <div className="carousel-video-slide" key={index}>

              <video
                className="video-gallery"
                poster={video.poster}
                controls={showControls && current === index}
                onClick={(e) => {
                  setShowControls(true);
                  e.currentTarget.play();
                }}
              >
                <source
                  src={video.src}
                  type="video/mp4"
                />
              </video>

            </div>
          ))}
        </div>

      </div>

      <button
        className="carousel-button carousel-button-left"
        onClick={previousVideo}
      >
        <img src={prevIcon} />
      </button>

      <button
        className="carousel-button carousel-button-right"
        onClick={nextVideo}
      >
        <img src={nextIcon} />
      </button>

    </section>
  );
}

export default Carousel;